import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPostcard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPostcard1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 9H12V10.5H6V9ZM14 9H18V14H14V9ZM6 12H10.02V13.5H6V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPostcard1;
